export enum RouteConsts {
  StoreTopPage = 'TopPage',
  ShowcasePage = 'Showcase',
  ResultsPage = 'ResultPage',
  ProductDetailPage = 'ProductDetailPage',
  CartPage = 'CartPage',
  BuyPage = 'BuyPage',
  // AboutPage = 'AboutPage',
  DocsPage = 'DocsPage',
  ContactUsPage = 'ContactUsPage',
  TermsPage = 'TermsPage',
  SecurityPolicyPage = 'SecurityPolicyPage',
  PrivacyPolicyPage = 'PrivacyPolicyPage',
  NotFoundPage = 'NotFoundPage',
  ConfirmEmailPage = 'ConfirmEmailPage',
  AsctPolicyPage = 'AsctPolicyPage',
  SupportPage = 'SupportPage',
  TutorialsPage = 'TutorialsPage',
  TutorialStepPage = 'TutorialStepPage'
}
